import { h } from 'preact';
import { PopAnnotation } from './index';
import { focusable } from 'utilities/accessibility';
import { expandable } from 'rendering/behaviors/expandable';
import { ControlBar } from 'rendering/components/adjacent_control_bar';
import { COMPOSITION_TYPES } from 'constants/annotations';

const { POP } = COMPOSITION_TYPES;

@expandable
export class AdjacentPopAnnotation extends PopAnnotation {
    static scalable = false

    render() {
        const style = {
            overflow: 'auto',
            ...this.getElementStyles(),
            width: '100%',
            height: '100%'
        };

        return (
            <div className={ this.classes } style={ style } { ...this.dataAttrs } { ...this.applyActions(this.actions) }>
                <ControlBar onExpand={ this.onExpand } onCollapse={ this.onCollapse } styles={ this.controlBarStyles }/>
                <div>
                    <div { ...focusable }>{ this.contents }</div>
                </div>
            </div>
        );
    }
}